import React from 'react';
import { useSelector } from 'react-redux';
import { Spectrum } from 'app/components/Spectrum';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { MainView } from './MainView';
/**
 * Application container
 */
export const App = () => {
    const dispatch = useAppDispatch();
    const colorScheme = useSelector((state) => state.editor.scheme);
    React.useEffect(() => {
        dispatch(EditorActions.startup());
    }, []);
    return (React.createElement(Spectrum, { colorScheme: colorScheme },
        React.createElement(MainView, null)));
};
